import imageResolver, { ResolvedImage } from "resolvers/data/imageResolver";
import richTextResolver, { ResolvedRichText } from "resolvers/data/richTextResolver";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { CustomSignUpBlock } from "services/cms/models/customSignUpBlock";

import marketingConsentResolver, {
    ResolvedMarketingContent,
} from "../../models/marketingConsentResolver";

export interface ResolvedCustomSignUpBlock {
    codename: string;
    id: string;
    type: ContentTypeCodenames.CustomSignUpBlock;
    header: string;
    subCopy: ResolvedRichText;
    marketingConsent: ResolvedMarketingContent;
    customSignUpCopy: string;
    contactSourceReason: string;
    bannerImagery: ResolvedImage;
    responseCopy: string;
    responseSubCopy: ResolvedRichText;
    resubmitText: string;
    responseImage: ResolvedImage;
    customerEmailTemplateName: string;
    internalEmailTemplateName: string;
    internalEmailAddress: string;
}

const customSignupBlockResolver = ({
    elements,
    system,
}: CustomSignUpBlock): ResolvedCustomSignUpBlock => {
    return {
        codename: system.codename,
        id: system.id,
        bannerImagery: imageResolver(elements.bannerImagery.linkedItems[0]),
        contactSourceReason: elements.contactSourceReason.value,
        responseCopy: elements.responseCopy.value,
        header: elements.header.value,
        marketingConsent: marketingConsentResolver(elements?.marketingConsent?.linkedItems?.[0]),
        responseSubCopy: richTextResolver({ html: elements?.responseSubCopy?.value }),
        customSignUpCopy: elements?.signUpCopy.value,
        subCopy: richTextResolver({ html: elements?.subCopy?.value }),
        responseImage: imageResolver(elements.responseImage?.linkedItems[0]),
        resubmitText: elements.resubmitText.value,
        type: ContentTypeCodenames.CustomSignUpBlock,
        customerEmailTemplateName: elements?.customerEmailTemplateName?.value,
        internalEmailTemplateName: elements?.internalEmailTemplateName?.value,
        internalEmailAddress: elements?.internalEmailAddress?.value,
    };
};

export default customSignupBlockResolver;
